// src/components/Auth.js
import React, { useState } from 'react';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider 
} from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';

const Auth = ({ onAuthSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  console.log('🔹 [Auth] Composant Auth rendu, onAuthSuccess:', typeof onAuthSuccess);

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    console.log('🔹 [Auth] Tentative auth email, isSignup:', isSignup, 'email:', email);
    
    try {
      let userCredential;
      
      if (isSignup) {
        // Création compte
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
        
        // Créer profil utilisateur dans Firestore
        await setDoc(doc(db, "users", userCredential.user.uid), {
          email: email,
          name: name,
          createdAt: new Date(),
          isBetaTester: true,
          profile: {
            level: "débutant",
            kettlebellWeight: null,
            totalSessions: 0,
            totalReps: 0,
            bestScore: 0
          }
        });
        
        console.log('✅ Compte créé:', userCredential.user.uid);
      } else {
        // Connexion
        userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log('✅ Connecté:', userCredential.user.uid);
      }

      console.log('🔹 [Auth] Appel onAuthSuccess avec user:', userCredential.user);
      onAuthSuccess(userCredential.user);
      console.log('🔹 [Auth] onAuthSuccess appelé');
    } catch (error) {
      console.error('❌ Erreur auth:', error);
      
      // Messages d'erreur en français
      let errorMessage = 'Une erreur est survenue';
      
      if (error.code === 'auth/email-already-in-use') {
        errorMessage = 'Cet email est déjà utilisé';
      } else if (error.code === 'auth/weak-password') {
        errorMessage = 'Mot de passe trop faible (min 6 caractères)';
      } else if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        errorMessage = 'Email ou mot de passe incorrect';
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = 'Email invalide';
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleAuth = async () => {
    setLoading(true);
    setError('');
    const provider = new GoogleAuthProvider();
    
    try {
      const result = await signInWithPopup(auth, provider);
      
      // Créer/mettre à jour profil
      await setDoc(doc(db, "users", result.user.uid), {
        email: result.user.email,
        name: result.user.displayName,
        photoURL: result.user.photoURL,
        createdAt: new Date(),
        isBetaTester: true,
        profile: {
          level: "débutant",
          kettlebellWeight: null,
          totalSessions: 0,
          totalReps: 0,
          bestScore: 0
        }
      }, { merge: true }); // merge: true pour ne pas écraser si existe déjà

      console.log('✅ Connexion Google réussie:', result.user.uid);
      console.log('🔹 [Auth] Appel onAuthSuccess avec user Google:', result.user);
      onAuthSuccess(result.user);
      console.log('🔹 [Auth] onAuthSuccess appelé après Google');
    } catch (error) {
      console.error('❌ Erreur Google auth:', error);
      setError('Erreur de connexion avec Google');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#1e1b2e',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        maxWidth: '400px',
        width: '100%'
      }}>
        {/* Logo/Titre */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img 
            src="/logo-kbfit.png" 
            alt="KB FIT Logo" 
            style={{ 
              width: '80px', 
              height: '80px', 
              marginBottom: '15px',
              filter: 'drop-shadow(0 4px 8px rgba(124, 58, 237, 0.3))'
            }} 
          />
          <h1 style={{ margin: 0, fontSize: '32px', color: '#333', fontWeight: 'bold' }}>
            KB FIT
          </h1>
          <p style={{ margin: '8px 0 0 0', color: '#999', fontSize: '14px' }}>
            Programme Beta • Accès Testeurs
          </p>
        </div>
        
        {/* Formulaire */}
        <form onSubmit={handleEmailAuth}>
          {isSignup && (
            <input
              type="text"
              placeholder="Prénom"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={inputStyle}
            />
          )}
          
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={inputStyle}
          />
          
          <input
            type="password"
            placeholder="Mot de passe (min 6 caractères)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            style={inputStyle}
          />
          
          {error && (
            <div style={{
              padding: '10px',
              background: '#FEE2E2',
              color: '#DC2626',
              borderRadius: '8px',
              marginBottom: '15px',
              fontSize: '14px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            disabled={loading}
            style={{
              ...buttonStyle,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? '⏳ Chargement...' : (isSignup ? '✨ Créer mon compte' : '🔓 Se connecter')}
          </button>
        </form>
        
        {/* Séparateur */}
        <div style={{ 
          margin: '20px 0', 
          textAlign: 'center', 
          color: '#999',
          fontSize: '14px',
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            right: 0,
            height: '1px',
            background: '#e0e0e0'
          }}/>
          <span style={{
            position: 'relative',
            background: 'white',
            padding: '0 10px'
          }}>
            OU
          </span>
        </div>
        
        {/* Bouton Google */}
        <button 
          onClick={handleGoogleAuth}
          disabled={loading}
          style={{
            ...buttonStyle, 
            background: '#4285F4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            opacity: loading ? 0.7 : 1,
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="white" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="white" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="white" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="white" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continuer avec Google
        </button>
        
        {/* Toggle signup/login */}
        <p style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#666' }}>
          {isSignup ? 'Déjà un compte ?' : 'Pas encore de compte ?'}
          {' '}
          <button 
            onClick={() => {
              setIsSignup(!isSignup);
              setError('');
            }}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#7C3AED', 
              cursor: 'pointer',
              textDecoration: 'underline',
              fontWeight: 'bold'
            }}
          >
            {isSignup ? 'Se connecter' : "S'inscrire"}
          </button>
        </p>

        {/* Note beta */}
        <div style={{
          marginTop: '20px',
          padding: '12px',
          background: 'rgba(251, 191, 36, 0.1)',
          border: '1px solid rgba(251, 191, 36, 0.3)',
          borderRadius: '8px',
          fontSize: '12px',
          color: '#F59E0B',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}>
          <span style={{ fontSize: '16px' }}>🔒</span>
          <span style={{ fontWeight: '600' }}>Données sécurisées • Programme Beta</span>
        </div>
      </div>
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '14px',
  marginBottom: '15px',
  border: '2px solid #e0e0e0',
  borderRadius: '10px',
  fontSize: '16px',
  boxSizing: 'border-box',
  transition: 'border-color 0.3s',
  ':focus': {
    borderColor: '#667eea',
    outline: 'none'
  }
};

const buttonStyle = {
  width: '100%',
  padding: '14px',
  background: '#7C3AED',
  color: 'white',
  border: 'none',
  borderRadius: '10px',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'transform 0.2s, box-shadow 0.2s',
  boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
};

export default Auth;
